<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>DEDICATION</p>
<p class="center">This work is dedicated to all animal lovers, especially those who have adopted and saved a life in need. We have dedicated over five years of our life building a community hand in hand with you, our incredible fans. Thank you for your continued support and humane treatment of our animal friends.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04dedication.vue?1f5ceef2